import { useContext } from 'react';

import { AmplitudeExperimentContext, AmplitudeExperimentContextValue } from './ExperimentContext';

const useExperiment = (): AmplitudeExperimentContextValue => {
  const context = useContext(AmplitudeExperimentContext);

  if (!context) {
    throw new Error('useExperiment must be used within ExperimentProvider');
  }

  return context;
};

export default useExperiment;
